import { jsx as _jsx } from "react/jsx-runtime";
import { byPrefixAndName } from '@awesome.me/kit-33eaf73f2e/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
const CHEVRON_RIGHT = byPrefixAndName.far['chevron-right'];
const Breadcrumbs = ({ children }) => {
    return (_jsx(MuiBreadcrumbs, { className: "breadcrumbs pb-1", "data-testid": "breadcrumbs", separator: _jsx(FontAwesomeIcon, { icon: CHEVRON_RIGHT }), children: children }));
};
export default Breadcrumbs;
